import { Loader } from "@tfg/ui"

import { useFindCertificateRequestsByCertificateId } from "~/gen/api/hooks/useFindCertificateRequestsByCertificateId"
import { CertificateByOrganizationDto } from "~/gen/api/types/CertificateByOrganizationDto"
import { findCertificateRequestsByCertificateIdHttpControllerFindCertificateRequestsByCertificateIdQueryParamsStatusEnum } from "~/gen/api/types/FindCertificateRequestsByCertificateId"
import { CompletedCertificateRequests } from "~/pages/Brand/Certificates/components/CompletedCertificateRequests"
import { SubmittedCertificateRequests } from "~/pages/Brand/Certificates/components/SubmittedCertificateRequests"

type CertificateRequestsValidationListProps = {
  certificate: CertificateByOrganizationDto
}

export const CertificateRequestsValidationList = ({
  certificate,
}: CertificateRequestsValidationListProps) => {
  const statuses = [
    findCertificateRequestsByCertificateIdHttpControllerFindCertificateRequestsByCertificateIdQueryParamsStatusEnum.SUBMITTED,
    findCertificateRequestsByCertificateIdHttpControllerFindCertificateRequestsByCertificateIdQueryParamsStatusEnum.ACCEPTED,
    findCertificateRequestsByCertificateIdHttpControllerFindCertificateRequestsByCertificateIdQueryParamsStatusEnum.REJECTED,
  ] as const

  const { data: certificateRequestsResponse, isLoading } =
    useFindCertificateRequestsByCertificateId({
      certificateId: certificate.id,
      status: [...statuses],
    })

  const certificateRequests = certificateRequestsResponse?.data

  if (!certificateRequests || isLoading) {
    return <Loader />
  }

  const completedCertificateRequests = [
    certificateRequests.accepted,
    certificateRequests.rejected,
  ]

  return (
    <>
      {completedCertificateRequests.map((data) => (
        <CompletedCertificateRequests key={data.status} data={data} />
      ))}
      <SubmittedCertificateRequests
        data={certificateRequests.submitted}
        certificate={certificate}
      />
    </>
  )
}
